import React from 'react';
import PropTypes from 'prop-types';
import MakeHash from 'make-hash';
import classNames from 'classnames';

export default class Cards extends React.Component {
  constructor (props) {
    super(props);
  }

  getChildren() {
    return typeof this.props.children.map === 'function' ? this.props.children : [this.props.children];
  }

  render() {
    const { dark, light, hasFooter, children, footerContent } = this.props;
    const cardsContainerClasses = classNames(
      'cards-container',
      {
        'cards-container_dark': dark,
        'cards-container_light': light
      }
    );
    const cardsFooterClasses = classNames(
      'cards-footer',
      {
        'cards-footer_isVisible': hasFooter
      }
    );

    return (
      <section className={cardsContainerClasses}>
        <div className="cards">
          {children}
        </div>
        <div className={cardsFooterClasses}>
          {footerContent}
        </div>
      </section>
    );
  }
}

Cards.propTypes = {
  dark: PropTypes.bool,
  light: PropTypes.bool,
  hasFooter: PropTypes.bool,
  footerContent: PropTypes.node
}



// WEBPACK FOOTER //
// ./src/client/components/cards/cards.jsx